import { Map } from 'immutable';

import { isObject } from '../../../isObject';

import { WAIT_FOR_SYNC } from '../../../../constants/shops';
import { OPERATIONS } from '../../../../constants/bulkEdit';
import { EMPTY } from '../../../../constants';
import ATTRIBUTE from '../../../../constants/attributes';

import actions from '../../../../actions';

export function videos({ channel, operation, preview }) {
  switch (operation) {
    case OPERATIONS[channel].VIDEOS.ADD: {
      return {
        actions: [actions.bulkEdit.setData({ waitForSync: WAIT_FOR_SYNC.FINISH })],
        payload: Map({
          type: operation,
          value: preview.getIn([ATTRIBUTE.VIDEOS, ATTRIBUTE.VIDEOS])
            .reduce(
              function reduceValue(result, value) {
                return result.push(
                  isObject(value) && !Map.isMap(value)
                    ? Map(value)
                    : value
                );
              },
              EMPTY.LIST
            ),
        }),
      };
    }

    case OPERATIONS[channel].VIDEOS.DELETE: {
      return {
        payload: Map({
          type: operation,
          value: Map({
            index: preview.getIn([ATTRIBUTE.VIDEOS, ATTRIBUTE.VIDEOS]).keySeq().toList().sort(),
          }),
        }),
      };
    }

    case OPERATIONS[channel].VIDEOS.REPLACE: {
      return {
        actions: [actions.bulkEdit.setData({ waitForSync: WAIT_FOR_SYNC.FINISH })],
        payload: preview.getIn([ATTRIBUTE.VIDEOS, ATTRIBUTE.VIDEOS]).reduce(
          function reducePreview(payload, video, index) {
            if (video) {
              payload.push(Map({ type: operation, value: Map({ index, video }) }));
            }

            return payload;
          },
          []
        ),
      };
    }

    default: {
      return {};
    }
  }
}
